<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    {{ respostaBase.pesquisa }}
                    <app-btn-voltar
                        class="float-right ml-2"
                        rota="Pesquisas_Respostas"
                        variant="secondary"
                    ></app-btn-voltar>
                </h5>
            </b-card-header>
            <b-card-body v-if="resposta">
                <span
                    >Usuário: <strong>{{ respostaBase.usuario }}</strong></span
                >
                <span v-if="respostaBase.fornecedor"
                    ><br />Fornecedor:
                    <strong>{{ respostaBase.fornecedor }}</strong></span
                >
                <span
                    ><br />Enviada em:
                    <strong>{{
                        $moment(respostaBase.dataAtualizacao).format(
                            'DD/MM/YYYY HH:mm'
                        )
                    }}</strong></span
                >
                <br />
                <b-row class="mt-4">
                    <b-col
                        sm="12"
                        v-for="detalhe in resposta.detalhes"
                        :key="detalhe.respostaDetalheId"
                    >
                        <h4>
                            <strong>{{ detalhe.pergunta }}</strong>
                        </h4>
                        <b-form-group>
                            <ckeditor
                                :editor="editor"
                                v-model="detalhe.resposta"
                                :config="editorConfig"
                                :disabled="true"
                            ></ckeditor>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br'
import PesquisasServicos from './PesquisasServicos'

export default {
    data() {
        return {
            resposta: {},
            respostaBase: {},
            editor: ClassicEditor,
            editorConfig: {
                language: 'pt-br',
                toolbar: []
            }
        }
    },

    methods: {
        obterResposta() {
            this.$store.dispatch('addRequest')
            PesquisasServicos.obterResposta(this.$route.params.respostaId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.resposta = response.data
                            this.respostaBase = response.data.resposta
                        } else {
                            this.$toast.error(
                                'Erro ao obter a resposta',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {
        this.obterResposta()
    }
}
</script>

<style>
.ck-editor__editable_inline {
    min-height: 100px;
}
</style>
